import {OnInit, Component, Input} from '@angular/core';
import { ShareDataService,EventBusService } from '@signature-it/ngx-generic/services';
import {EventName} from "@signature-it/ngx-generic/classes";

@Component({
    selector: 'cms-link-embeded',
    templateUrl: './cms-link-embeded.html',
    styleUrls: ['./cms-link-embeded.scss'],
    standalone: false
})
export class CmsLinkEmbededComponentGeneric implements  OnInit{
    @Input() cmsTitle: string;
    @Input() cmsLink: string;
    @Input() isMobileButton: boolean;
    @Input() isMaxWidth: boolean;
    @Input() hideCloseBtn: boolean = false;
    @Input() isActive: boolean = false;
    @Input() closeAfter: number = null;
    @Input() cmsId: string = '';
    active: boolean= false;
    constructor(public shareSvc: ShareDataService, public eventBusService: EventBusService) { }

    ngOnInit() {
        const self = this;
        this.eventBusService.on(`${EventName.CMS_LOAD}-${this.cmsTitle}`, completed => {
            if (completed) {
                self.active = self.isActive;
                if(self.closeAfter){
                    setTimeout(function () {
                        self.active = false;
                    }, self.closeAfter);
                }

            }
        });
    }

    setMaxWidth() {
        if (this.isMaxWidth) {
            let elem = document.getElementById('cms-embeded');
            let parent = elem.parentElement;
            let elemLeft = parent.offsetLeft;
            elem.style.left = elemLeft + "px";
            elem.style.right = "0";
        }
    }
}
